import cyrinoIcon from '../assets/cyrino-icon.svg';

const ICON_SELECTOR = 'link[rel="icon"]';

/**
 * Every Cyrino app shows the same tab icon, called once from each app's
 * `main.tsx`. It is set here rather than in each `index.html` so there is one
 * file and no copies: a link in `index.html` cannot reach a workspace package
 * from the dev server, while an import is bundled in dev and build alike.
 */
export const applyCyrinoFavicon = (): void => {
  const existing = document.head.querySelector<HTMLLinkElement>(ICON_SELECTOR);
  const link = existing ?? document.head.appendChild(document.createElement('link'));

  link.rel = 'icon';
  link.type = 'image/svg+xml';
  link.href = cyrinoIcon;
};
